import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLocationsList,
  createOrUpdateLocation,
  deleteLocation,
} from "./locationsThunks";

const locationsSlice = createSlice({
  name: "locations",
  initialState: {
    locations: [],
    loading: false,
    error: null,
    successMessage: null,
    selectedLocation: null,
    isEditLocation: false,
  },
  reducers: {
    resetLocationManageStatus: (state) => {
      state.successMessage = null;
    },
    setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
    setIsEditLocation: (state, action) => {
      state.isEditLocation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocationsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLocationsList.fulfilled, (state, action) => {
        state.loading = false;
        state.locations = action.payload;
      })
      .addCase(createOrUpdateLocation.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      })
      .addCase(deleteLocation.fulfilled, (state, action) => {
        state.successMessage = action.payload.message;
      });
  },
});

export const {
  resetLocationManageStatus,
  setSelectedLocation,
  setIsEditLocation,
} = locationsSlice.actions;

export default locationsSlice.reducer;
